import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Film } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/AuthContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();
  const { t } = useTranslation();

  const NAV_LINKS = [
    { to: "/como-funciona", label: t("nav.how_it_works"), key: "how-it-works" },
    { to: "/explorar", label: t("nav.explore"), key: "explore" },
    { to: "/vitrina", label: t("nav.vitrina"), key: "vitrina" },
    { to: "/como-funciona#modalidades", label: t("nav.modalities"), key: "modalities" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 backdrop-blur-xl bg-[#0B1320]/70">
      <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="link-home-logo">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-gold text-petroleum">
            <Film size={18} />
          </span>
          <span className="font-display text-2xl tracking-tight text-white">
            Cine<span className="text-gold">ngage</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-white/80">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`link-nav-${l.key}`}
              className="hover:text-gold transition-colors"
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher variant="dark" />
          {user ? (
            <button
              onClick={() => nav("/dashboard")}
              className="gold-cta rounded-full px-5 py-2 text-sm font-semibold"
              data-testid="button-nav-dashboard"
            >
              {t("nav.go_to_panel")}
            </button>
          ) : (
            <>
              <Link
                to="/login"
                className="text-sm text-white/80 hover:text-white transition-colors"
                data-testid="link-nav-login"
              >
                {t("nav.login")}
              </Link>
              <Link
                to="/registro"
                className="gold-cta rounded-full px-5 py-2 text-sm font-semibold"
                data-testid="link-nav-register"
              >
                {t("nav.register")}
              </Link>
            </>
          )}
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
          aria-label="Menú"
          data-testid="button-nav-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0B1320] px-6 py-6 space-y-4">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block text-white/80 hover:text-gold"
            >
              {l.label}
            </Link>
          ))}
          <div className="border-t border-white/10 pt-4 flex flex-col gap-3">
            <LanguageSwitcher variant="dark" />
            {user ? (
              <Link to="/dashboard" onClick={() => setOpen(false)} className="gold-cta rounded-full px-5 py-2 text-sm font-semibold text-center">
                {t("nav.go_to_panel")}
              </Link>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-white/80">
                  {t("nav.login")}
                </Link>
                <Link to="/registro" onClick={() => setOpen(false)} className="gold-cta rounded-full px-5 py-2 text-sm font-semibold text-center">
                  {t("nav.register")}
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
